import HookFormSwitchInput from 'src/hook-form-wrapper/switch-input';
import React from 'react';
import {useTranslations} from 'src/providers/translation';

const Supervision = ({name}: any) => {
  const translations = useTranslations();

  return (
    <HookFormSwitchInput
      name={(name ? name + '.' : '') + 'supervision'}
      label={translations('supervision')}
    />
  );
};

export default Supervision;
